/**
 * YazioGoalsPage - Router wrapper for Yazio Goals
 * Provides data and renders the goals content
 */

import React from "react";

import { YazioGoalsTab } from "../organisms/YazioGoalsTab";

export const YazioGoalsPage: React.FC = () => {
  return <YazioGoalsTab />;
};
